import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: "app-evento-formulario",
  templateUrl: "./formulario.component.html"
})
export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tab = 1;
  CkeditorConfig = {
    height: document.body.clientHeight - 560
  };

  form_eventos_costos = {
    id: [""],
    eventos_id: [""],
    nombre: ["", [Validators.required]],
    importe: ["", [Validators.required]]
  };

  form_eventos_secciones = {
    id: [""],
    eventos_id: [""],
    nombre: ["", [Validators.required]],
    fecha: ["", [Validators.required]],
    hora_inicio: ["", [Validators.required]],
    hora_termino: ["", [Validators.required]]
  };

  form_eventos_constancias = {
    id: [""],
    eventos_id: [""],
    orientacion: ["portrait", [Validators.required]],
    tamanio_papel: ["", [Validators.required]],
    background: [""],
    mm_x: ["", [Validators.required]],
    mm_y: ["", [Validators.required]],
    font_family: ["", [Validators.required]],
    font_size: ["", [Validators.required]],
    color: ["", [Validators.required]],
    porcentaje_reconocimiento: [""]
  };

  form_eventos_encuestas = {
    id: [""],
    eventos_id: [""],
    encuestas_id: ["", [Validators.required]]
  };

  tamanios_papel = [
    { id: "841:1189", text: "A0" },
    { id: "594:841", text: "A1" },
    { id: "420:594", text: "A2" },
    { id: "297:420", text: "A3" },
    { id: "210:297", text: "A4" },
    { id: "148:210", text: "A5" },
    { id: "216:279", text: "CARTA" },
    { id: "216:356", text: "OFICIO" },
    { id: "279:432", text: "TABLOIDE" }
  ];

  fonts = [
    { id: "auto", text: "AUTO" },
    { id: "cursive", text: "CURSIVE" },
    { id: "fantasy", text: "FANTASY" },
    { id: "monospace", text: "MONOSPACE" },
    { id: "sans-serif", text: "SANS-SERIF" },
    { id: "serif", text: "SERIF" }
  ];
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.dato = this.fb.group({
      id: [""],
      categorias_eventos_id: ["", [Validators.required]],
      nombre: ["", [Validators.required]],
      descripcion: [""],
      imagen: [""],
      inicio_inscripcion: ["", [Validators.required]],
      fin_inscripcion: ["", [Validators.required]],
      fecha_inicio: ["", [Validators.required]],
      fecha_termino: ["", [Validators.required]],
      mensaje_email: [""],
      tipo_codigo: [2, [Validators.required]],
      longitud_codigo: ["", [Validators.required]],
      eventos_costos: this.fb.array([]),
      eventos_secciones: this.fb.array([]),
      eventos_constancias: this.fb.array([]),
      eventos_encuestas: this.fb.array([])
    });

    document.getElementById("catalogos").click();
  }
}
